import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { CardZeroState } from 'ecs-react-components/dist/index.es';
import PersonalContactCard from '../../components/Person/PersonalContactCard';
import { messages } from './PersonalContacts.i18n';
import { loadPersonalContacts } from '../../redux/modules/personal-contacts/personal-contacts-middleware';
import AddContactButton from './Contact/AddContactButton';
import { setPersonalContactId } from '../../redux/modules/personal-contacts/personal-contacts-action-creator';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';
import history from '../../history';

class PersonalContacts extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      dispatch,
      patientId,
    } = this.props;

    if (patientId) {
      dispatch(
        callWithLoadingIndicator('PersonalContacts', () => dispatch(loadPersonalContacts(patientId))));
      dispatch(setPersonalContactId(null));
    }
  }

  handleEditContactClick = (contactId) => () => {
    this.props.dispatch(setPersonalContactId(contactId));
    history.push('/edit-contact');
  }

  sortPersonalContacts() {
    return this.props.personalContacts.sort((x, y) => {
      if (x.contactFirstName.toLowerCase() < y.contactFirstName.toLowerCase()) return -1;
      if (x.contactFirstName.toLowerCase() > y.contactFirstName.toLowerCase()) return 1;
      if (x.contactLastName.toLowerCase() < y.contactLastName.toLowerCase()) return -1;
      if (x.contactLastName.toLowerCase() > y.contactLastName.toLowerCase()) return 1;
      return 0;
    });
  }

  hasAddContactLink = () => {
    const { capabilitySetting } = this.props;
    const addContactLink = capabilitySetting && capabilitySetting.details ?
      !!capabilitySetting.details.find((x) => x.fieldName === 'AddContact') : false;
    return addContactLink;
  };

  renderPersonalContactCard = (contact, isDisplayAddContact, contactIndex) =>
    (<PersonalContactCard key={contactIndex.toString()} contact={ contact } editClick={this.handleEditContactClick}
      windowSize={this.props.windowSize} authorizeClick={this.handleEditContactClick}
      isDisplayAddContact={isDisplayAddContact}
    />);

  render() {
    const isDisplayAddContact = this.hasAddContactLink();
    return (
      <div data-qa-container="personalContactsContainer">
        <LoadingIndicatorContainer loadingKey="PersonalContacts" size="small">
          <div className="row pt-3 mb-1">
            <div className="col">
              <h2 tabIndex={0}><FormattedMessage {...messages.header} /></h2>
            </div>
            { isDisplayAddContact ? <AddContactButton /> : null }
          </div>
          {
            this.props.personalContacts.length > 0 ?
              <div className="row row-cols-1 row-cols-md-3 g-4 mb-3 small">
                {
                this.sortPersonalContacts().map(
                  (contact, contactIndex) => (
                    this.renderPersonalContactCard(contact, isDisplayAddContact, contactIndex)))
                  }
              </div>
              :
              <CardZeroState
                zeroStateMessage={ <FormattedMessage {...messages.label.noContacts} /> }
                stateIconCss="fa-calendar"
              />
          }
        </LoadingIndicatorContainer>
      </div>
    );
  }
}

PersonalContacts.propTypes = {
  dispatch: PropTypes.func,
  personalContacts: PropTypes.array,
  capabilitySetting: PropTypes.object,
  windowSize: PropTypes.string,
  patientId: PropTypes.string,
};

const mapStateProps = (state) => ({
  personalContacts: state.personalContacts.personalContacts,
  windowSize: state.window.size,
  patientId: state.profile.patient.patientId,
});

export default connect(mapStateProps)(PersonalContacts);